import { webApi } from '@mi-front/api-clients';
import { useMemo } from 'react';
import { clampTimeRangeToDomain } from '../lib/quality-time-range';
import { VisibleTimeRange } from '../lib/visible-time-range';
import { buildIssuesTableRows } from './build-issues-table-rows';
import { IssuesTableRow } from './issues-table-row';

/**
 * Derives issues-table rows: full report flatten + sort only when `report` or `stationIds` change;
 * visible brush window is applied in a separate memo so dragging the range does not rebuild from raw report data.
 */
export function useIssuesTableRows(
  report: webApi.StreamQualityReportResponseDto,
  stationIds: string[],
  visibleRange: VisibleTimeRange,
): IssuesTableRow[] {
  const visibleFromMs = visibleRange.from.getTime();
  const visibleToMs = visibleRange.to.getTime();

  const rowsForStationFilter = useMemo(() => {
    const all = buildIssuesTableRows(report);
    if (stationIds.length === 0) {
      return [];
    }
    const allow = new Set(stationIds);
    return all.filter((row) => allow.has(row.stationId));
  }, [report, stationIds]);

  return useMemo(() => {
    const rangeFrom = new Date(visibleFromMs);
    const rangeTo = new Date(visibleToMs);
    return rowsForStationFilter.filter(
      (row) =>
        clampTimeRangeToDomain(row.payload.start, row.payload.end, rangeFrom, rangeTo) != null,
    );
  }, [rowsForStationFilter, visibleFromMs, visibleToMs]);
}
